<template>
  <div class="navbar">
    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />
    <div class="logoGroup">
      <a
        href
        class="logo"
      >
        <img src="../../../assets/images/logo.png">
      </a>
      <img
        class="planIcon"
        src="../../../assets/images/icon.png"
      >
      <span class="spanText">GTM Plan Validation Tool</span>
      <span class="qaSignal">QA Environment</span>
      <el-dropdown
        class="avatar-container"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span class="avatar-name">
            hello!
            <b>{{this.fullName}}</b>
          </span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu
          slot="dropdown"
          class="user-dropdown"
        >
          <router-link
            class="inlineBlock"
            to="/"
          >
            <el-dropdown-item>Home</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span
              style="display:block;"
              @click="logout"
            >LogOut</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Hamburger from "@/components/Hamburger";
import { revoke } from "../../../api/system";

export default {
  data () {
    return {
      userName: ""
    };
  },
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch("ToggleSideBar");
    },
    logout () {
      return new Promise(resolve => {
        sessionStorage.clear();
        resolve();
      })
        .then(() => {
          window.location.href = "https://fedauthtst.pg.com/idp/startSLO.ping?TargetResource=https://fedauthtst.pg.com/ext/logout";
        })
        .catch(error => {
          reject(error);
        });
    },
    showUserName () {
      this.fullName = JSON.parse(sessionStorage.getItem("userInfo")).fullName;
    }
  },
  beforeMount () {
    this.showUserName();
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  /* line-height: 50px; */
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .spanText {
    margin-top: 10px;
    margin-left: 10px;
    font-size: 1.3rem;
  }
  .planIcon {
    height: 30px;
    width: 30px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .logoGroup {
    display: flex;
    align-items: center;
    width: 80%;
  }

  .logo {
    float: left;

    img {
      height: 30px;
      margin-top: 10px;
    }
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    margin-top: 5px;
    font-size: 1rem;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      line-height: initial;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .avatar-name {
        float: right;
        line-height: 40px;
        text-transform: capitalize;
        margin: 0 0 0 15px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 15px;
        font-size: 12px;
      }
    }
  }
}
.el-popper {
  margin-top: 5px;
}
.qaSignal {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 36px;
  margin-left: 20px;
  margin-top: 6px;
  color: red;
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue